import { getLocaleCode as getAppLocale } from '@dragonfruit/redux/locale';
import {
  generateURL,
  generateURLWithoutLocale,
} from '@dragonfruit/utils/navigation';

import config from '@dragonfruit/config';
const {
  SNAPASK_SITE_ENDPOINT,
  ACADEMY_SITE_ENDPOINT,
  SNAPASK_QA_ROOT_PATH: SNAPASK_QA_SITE_ENDPOINT,
} = config;

const action = actionName => `NAV:${actionName}`;

export const HOME = action('HOME');
export const LOGIN = action('LOGIN');
export const SIGNUP = action('SIGNUP');
export const FACEBOOK_SIGNUP = action('FACEBOOK_SIGNUP');
export const GO_TUTOR_SIGNUP = action('GO_TUTOR_SIGNUP');
export const TUTOR_FACEBOOK_SIGNUP = action('TUTOR_FACEBOOK_SIGNUP');
export const PREVIOUS_LOCATION = action('PREVIOUS_LOCATION');
export const OPEN_EXTERNAL_URL = action('OPEN_EXTERNAL_URL');
export const VERIFY_PHONE = action('VERIFY_PHONE');
export const PAYMENT_RECEIPT = action('PAYMENT_RECEIPT');
export const PAYMENT_RECEIPT_FOR_OFFLINE = action(
  'PAYMENT_RECEIPT_FOR_OFFLINE'
);
export const PREMIUM = action('PREMIUM');
export const GO_PURCHASE_PAGE = action('GO_PURCHASE_PAGE');
export const GO_CHANGE_PLAN_PAGE = action('GO_CHANGE_PLAN_PAGE');
export const GO_MY_LEARNING_PAGE = action('GO_MY_LEARNING_PAGE');
export const GO_ACCOUNT_SETUP_PAGE = action('GO_ACCOUNT_SETUP_PAGE');
export const ACCOUNT = action('ACCOUNT');
export const ACCOUNT_REFERRAL = action('ACCOUNT_REFERRAL');
export const ACCOUNT_TEACHINGS = action('ACCOUNT_TEACHINGS');
export const ACCOUNT_SUBSCRIPTIONS = action('ACCOUNT_SUBSCRIPTIONS');
export const ACCOUNT_SUBSCRIPTION_CANCEL = action(
  'ACCOUNT_SUBSCRIPTION_CANCEL'
);
export const REDIRECT_TO_PARTNER_DEMO_CONFIRM = action(
  'REDIRECT_TO_PARTNER_DEMO_CONFIRM'
);
export const COCONUT = action('COCONUT');
export const DOWNLOAD = action('DOWNLOAD');
export const CONFIRM_DELETE_ACCOUNT = action('CONFIRM_DELETE_ACCOUNT');
export const DELETE_ACCOUNT = action('DELETE_ACCOUNT');
export const VERIFY_TUTOR_EMAIL = action('VERIFY_TUTOR_EMAIL');
export const EMAIL_NOT_VERIFIED = action('EMAIL_NOT_VERIFIED');
export const AUDIT_TUTOR_INFROMATION = action('AUDIT_TUTOR_INFROMATION');

export const TUTOR_LIST = action('TUTOR_LIST');

export const home = () => ({
  type: HOME,
});

export const login = () => ({
  type: LOGIN,
});

export const signup = () => ({
  type: SIGNUP,
});

export const facebookSignup = () => ({
  type: FACEBOOK_SIGNUP,
});

export const goToTutorSignupPage = () => ({
  type: GO_TUTOR_SIGNUP,
});

export const paymentReceipt = () => ({
  type: PAYMENT_RECEIPT,
});

export const paymentReceiptForOffline = payload => ({
  type: PAYMENT_RECEIPT_FOR_OFFLINE,
  payload,
});

export const premium = () => ({
  type: PREMIUM,
});

export const goToPurchasePage = paymentMethodId => ({
  type: GO_PURCHASE_PAGE,
  paymentMethodId,
});

export const goToChangePlanPage = (changePlanType, subscriptionId) => ({
  type: GO_CHANGE_PLAN_PAGE,
  payload: {
    changePlanType,
    subscriptionId,
  },
});

export const verifyTutorEmail = () => ({
  type: VERIFY_TUTOR_EMAIL,
});

export const auditTutorInformation = () => ({
  type: AUDIT_TUTOR_INFROMATION,
});

export const openExternalUrl = (url, newTab = false) => ({
  type: OPEN_EXTERNAL_URL,
  payload: {
    url,
    newTab,
  },
});

export const goToAccountSetupPage = userLocale => ({
  type: GO_ACCOUNT_SETUP_PAGE,
  payload: {
    userLocale,
  },
});

export const account = () => ({
  type: ACCOUNT,
});

export const goToAccountSubscriptionsPage = () => ({
  type: ACCOUNT_SUBSCRIPTIONS,
});

export const goToAccountSubscriptionCancelPage = subscriptionId => ({
  type: ACCOUNT_SUBSCRIPTION_CANCEL,
  payload: {
    subscriptionId,
  },
});

export const previous = () => ({
  type: PREVIOUS_LOCATION,
});

export const redirectToPartnerDemoConfirm = () => ({
  type: REDIRECT_TO_PARTNER_DEMO_CONFIRM,
});

export const coconut = (hash = '') => ({
  type: COCONUT,
  payload: {
    hash,
  },
});

export const download = () => ({
  type: DOWNLOAD,
});

export const confirmDeleteAccount = () => ({
  type: CONFIRM_DELETE_ACCOUNT,
});

export const deleteAccount = () => ({
  type: DELETE_ACCOUNT,
});

export const tutorList = filterName => ({
  type: TUTOR_LIST,
  payload: {
    filterName,
  },
});

export const generateOfficialSiteURL = state => {
  const locale = getAppLocale(state);
  return (path, params, customizedLocale) =>
    generateURL({
      path,
      baseUrl: SNAPASK_SITE_ENDPOINT,
      params,
      locale: customizedLocale || locale,
    });
};

export const generateAcademyURL = state => {
  const locale = getAppLocale(state);
  return (path, params) =>
    generateURL({ path, baseUrl: ACADEMY_SITE_ENDPOINT, params, locale });
};

export const generateQuestionAskURL = () => {
  return (path, params) =>
    generateURLWithoutLocale({
      path,
      baseUrl: SNAPASK_QA_SITE_ENDPOINT,
      params,
    });
};



// WEBPACK FOOTER //
// ./app/redux/navigation.js